export const countryList = [
  { value: 'CHN', text: '中国大陆', enName: 'China' },
  { value: 'ABW', text: '阿鲁巴', enName: 'Aruba' },
  { value: 'AFG', text: '阿富汗', enName: 'Afghanistan' },
  { value: 'AGO', text: '安哥拉', enName: 'Angola' },
  { value: 'AIA', text: '安圭拉', enName: 'Anguilla' },
  { value: 'ALB', text: '阿尔巴尼亚', enName: 'Albania' },
  { value: 'AND', text: '安道尔', enName: 'Andorra' },
  { value: 'ANT', text: '荷属安的列斯', enName: 'Netherlands Antilles' },
  { value: 'ARE', text: '阿联酋', enName: 'United Arab Emirates' },
  { value: 'ARG', text: '阿根廷', enName: 'Argentina' },
  { value: 'ARM', text: '亚美尼亚', enName: 'Armenia' },
  { value: 'ASM', text: '美属萨摩亚', enName: 'American Samoa' },
  { value: 'ATA', text: '南极洲', enName: 'Antarctica' },
  {
    value: 'ATF',
    text: '法属南部领土',
    enName: 'French Southern Territories'
  },
  { value: 'ATG', text: '安提瓜和巴布达', enName: 'Antigua & Barbuda' },
  { value: 'AUS', text: '澳大利亚', enName: 'Australia' },
  { value: 'AUT', text: '奥地利', enName: 'Austria' },
  { value: 'AZE', text: '阿塞拜疆', enName: 'Azerbaijan' },
  { value: 'BDI', text: '布隆迪', enName: 'Burundi' },
  { value: 'BEL', text: '比利时', enName: 'Belgium' },
  { value: 'BEN', text: '贝宁', enName: 'Benin' },
  { value: 'BFA', text: '布基纳法索', enName: 'Burkina' },
  { value: 'BGD', text: '孟加拉国', enName: 'Bangladesh' },
  { value: 'BGR', text: '保加利亚', enName: 'Bulgaria' },
  { value: 'BHR', text: '巴林', enName: 'Bahrain' },
  { value: 'BHS', text: '巴哈马', enName: 'The Bahamas' },
  {
    value: 'BIH',
    text: '波斯尼亚和黑塞哥维那',
    enName: 'Bosnia & Herzegovina'
  },
  { value: 'BLR', text: '白俄罗斯', enName: 'Belarus' },
  { value: 'BLZ', text: '伯利兹', enName: 'Belize' },
  { value: 'BMU', text: '百慕大', enName: 'Bermuda' },
  { value: 'BOL', text: '玻利维亚', enName: 'Bolivia' },
  { value: 'BRA', text: '巴西', enName: 'Brazil' },
  { value: 'BRB', text: '巴巴多斯', enName: 'Barbados' },
  { value: 'BRN', text: '文莱', enName: 'Brunei' },
  { value: 'BTN', text: '不丹', enName: 'Bhutan' },
  { value: 'BVT', text: '布维岛', enName: 'Bouvet Island' },
  { value: 'BWA', text: '博茨瓦纳', enName: 'Botswana' },
  { value: 'CAF', text: '中非', enName: 'Central African Republic' },
  { value: 'CAN', text: '加拿大', enName: 'Canada' },
  {
    value: 'CCK',
    text: '科科斯（基林）群岛',
    enName: 'Cocos (Keeling) Islands'
  },
  { value: 'CHE', text: '瑞士', enName: 'Switzerland' },
  { value: 'CHL', text: '智利', enName: 'Chile' },
  { value: 'CIV', text: '科特迪瓦', enName: "Côte d'Ivoire" },
  { value: 'CMR', text: '喀麦隆', enName: 'Cameroon' },
  {
    value: 'COD',
    text: '刚果（金）',
    enName: 'Democratic Republic of the Congo'
  },
  { value: 'COG', text: '刚果（布）', enName: 'Republic of the Congo' },
  { value: 'COK', text: '库克群岛', enName: 'Cook Islands' },
  { value: 'COL', text: '哥伦比亚', enName: 'Colombia' },
  { value: 'COM', text: '科摩罗', enName: 'Comorin' },
  { value: 'CPV', text: '佛得角', enName: 'Cape Verde' },
  { value: 'CRI', text: '哥斯达黎加', enName: 'Costa Rica' },
  { value: 'CTN', text: '中国台湾', enName: 'China Taiwan' },
  { value: 'CUB', text: '古巴', enName: 'Cuba' },
  { value: 'CXR', text: '圣诞岛', enName: 'Christmas Island' },
  { value: 'CYM', text: '开曼群岛', enName: 'Cayman Islands' },
  { value: 'CYP', text: '塞浦路斯', enName: 'Cyprus' },
  { value: 'CZE', text: '捷克', enName: 'Czech Republic' },
  { value: 'DEU', text: '德国', enName: 'Germany' },
  { value: 'DJI', text: '吉布提', enName: 'Djibouti' },
  { value: 'DMA', text: '多米尼克', enName: 'Dominica' },
  { value: 'DNK', text: '丹麦', enName: 'Denmark' },
  { value: 'DOM', text: '多米尼加共和国', enName: 'Dominican Republic' },
  { value: 'DZA', text: '阿尔及利亚', enName: 'Algeria' },
  { value: 'ECU', text: '厄瓜多尔', enName: 'Ecuador' },
  { value: 'EGY', text: '埃及', enName: 'Egypt' },
  { value: 'ERI', text: '厄立特里亚', enName: 'Eritrea' },
  { value: 'ESH', text: '西撒哈拉', enName: 'Western Sahara' },
  { value: 'ESP', text: '西班牙', enName: 'Spain' },
  { value: 'EST', text: '爱沙尼亚', enName: 'Estonia' },
  { value: 'ETH', text: '埃塞俄比亚', enName: 'Ethiopia' },
  { value: 'FIN', text: '芬兰', enName: 'Finland' },
  { value: 'FJI', text: '斐济', enName: 'Fiji' },
  {
    value: 'FLK',
    text: '马尔维纳斯群岛（福克兰群岛）',
    enName: 'Falkland Islands'
  },
  { value: 'FRA', text: '法国', enName: 'France' },
  { value: 'FRO', text: '法罗群岛', enName: 'Faroe Islands' },
  {
    value: 'FSM',
    text: '密克罗尼西亚',
    enName: 'Federated States of Micronesia'
  },
  { value: 'GAB', text: '加蓬', enName: 'Gabon' },
  {
    value: 'GBR',
    text: '英国',
    enName: 'Great Britain (United Kingdom; England)'
  },
  { value: 'GEO', text: '格鲁吉亚', enName: 'Georgia' },
  { value: 'GHA', text: '加纳', enName: 'Ghana' },
  { value: 'GIB', text: '直布罗陀', enName: 'Gibraltar' },
  { value: 'GIN', text: '几内亚', enName: 'Guinea' },
  { value: 'GLP', text: '瓜德罗普', enName: 'Guadeloupe' },
  { value: 'GMB', text: '冈比亚', enName: 'Gambia' },
  { value: 'GNB', text: '几内亚比绍', enName: 'Guinea-Bissau' },
  { value: 'GNQ', text: '赤道几内亚', enName: 'Equatorial Guinea' },
  { value: 'GRC', text: '希腊', enName: 'Greece' },
  { value: 'GRD', text: '格林纳达', enName: 'Grenada' },
  { value: 'GRL', text: '格陵兰', enName: 'Greenland' },
  { value: 'GTM', text: '危地马拉', enName: 'Guatemala' },
  { value: 'GUF', text: '法属圭亚那', enName: 'French Guiana' },
  { value: 'GUM', text: '关岛', enName: 'Guam' },
  { value: 'GUY', text: '圭亚那', enName: 'Guyana' },
  { value: 'HKG', text: '中国香港', enName: 'China Hongkong' },
  {
    value: 'HMD',
    text: '赫德岛和麦克唐纳岛',
    enName: 'Heard Island and McDonald Islands'
  },
  { value: 'HND', text: '洪都拉斯', enName: 'Honduras' },
  { value: 'HRV', text: '克罗地亚', enName: 'Croatia' },
  { value: 'HTI', text: '海地', enName: 'Haiti' },
  { value: 'HUN', text: '匈牙利', enName: 'Hungary' },
  { value: 'IDN', text: '印度尼西亚', enName: 'Indonesia' },
  { value: 'IND', text: '印度', enName: 'India' },
  {
    value: 'IOT',
    text: '英属印度洋领土',
    enName: 'British Indian Ocean Territory'
  },
  { value: 'IRL', text: '爱尔兰', enName: 'Ireland' },
  { value: 'IRN', text: '伊朗', enName: 'Iran' },
  { value: 'IRQ', text: '伊拉克', enName: 'Iraq' },
  { value: 'ISL', text: '冰岛', enName: 'Iceland' },
  { value: 'ISR', text: '以色列', enName: 'Israel' },
  { value: 'ITA', text: '意大利', enName: 'Italy' },
  { value: 'JAM', text: '牙买加', enName: 'Jamaica' },
  { value: 'JEY', text: '泽西岛', enName: 'Jersey' },
  { value: 'JOR', text: '约旦', enName: 'Jordan' },
  { value: 'JPN', text: '日本', enName: 'Japan' },
  { value: 'KAZ', text: '哈萨克斯坦', enName: 'Kazakhstan' },
  { value: 'KEN', text: '肯尼亚', enName: 'Kenya' },
  { value: 'KGZ', text: '吉尔吉斯斯坦', enName: 'Kyrgyzstan' },
  { value: 'KHM', text: '柬埔寨', enName: 'Cambodia' },
  { value: 'KIR', text: '基里巴斯', enName: 'Kiribati' },
  { value: 'KNA', text: '圣基茨和尼维斯', enName: 'St. Kitts & Nevis' },
  { value: 'KOR', text: '韩国', enName: 'South Korea' },
  { value: 'KWT', text: '科威特', enName: 'Kuwait' },
  { value: 'LAO', text: '老挝', enName: 'Laos' },
  { value: 'LBN', text: '黎巴嫩', enName: 'Lebanon' },
  { value: 'LBR', text: '利比里亚', enName: 'Liberia' },
  { value: 'LBY', text: '利比亚', enName: 'Libya' },
  { value: 'LCA', text: '圣卢西亚', enName: 'St. Lucia' },
  { value: 'LIE', text: '列支敦士登', enName: 'Liechtenstein' },
  { value: 'LKA', text: '斯里兰卡', enName: 'Sri Lanka' },
  { value: 'LSO', text: '莱索托', enName: 'Lesotho' },
  { value: 'LTU', text: '立陶宛', enName: 'Lithuania' },
  { value: 'LUX', text: '卢森堡', enName: 'Luxembourg' },
  { value: 'LVA', text: '拉脱维亚', enName: 'Latvia' },
  { value: 'MAC', text: '中国澳门', enName: 'China Macau' },
  { value: 'MAR', text: '摩洛哥', enName: 'Morocco' },
  { value: 'MCO', text: '摩纳哥', enName: 'Monaco' },
  { value: 'MDA', text: '摩尔多瓦', enName: 'Moldova' },
  { value: 'MDG', text: '马达加斯加', enName: 'Madagascar' },
  { value: 'MDV', text: '马尔代夫', enName: 'Maldives' },
  { value: 'MEX', text: '墨西哥', enName: 'Mexico' },
  { value: 'MHL', text: '马绍尔群岛', enName: 'Marshall islands' },
  { value: 'MKD', text: '马其顿', enName: 'Republic of Macedonia (FYROM)' },
  { value: 'MLI', text: '马里', enName: 'Mali' },
  { value: 'MLT', text: '马耳他', enName: 'Malta' },
  { value: 'MMR', text: '缅甸', enName: 'Myanmar (Burma)' },
  { value: 'MNG', text: '蒙古', enName: 'Mongolia' },
  { value: 'MNP', text: '北马里亚纳', enName: 'Northern Mariana Islands' },
  { value: 'MOZ', text: '莫桑比克', enName: 'Mozambique' },
  { value: 'MRT', text: '毛里塔尼亚', enName: 'Mauritania' },
  { value: 'MSR', text: '蒙特塞拉特', enName: 'Montserrat' },
  { value: 'MTQ', text: '马提尼克', enName: 'Martinique' },
  { value: 'MUS', text: '毛里求斯', enName: 'Mauritius' },
  { value: 'MWI', text: '马拉维', enName: 'Malawi' },
  { value: 'MYS', text: '马来西亚', enName: 'Malaysia' },
  { value: 'MYT', text: '马约特', enName: 'Mayotte' },
  { value: 'NAM', text: '纳米比亚', enName: 'Namibia' },
  { value: 'NCL', text: '新喀里多尼亚', enName: 'New Caledonia' },
  { value: 'NER', text: '尼日尔', enName: 'Niger' },
  { value: 'NFK', text: '诺福克岛', enName: 'Norfolk Island' },
  { value: 'NGA', text: '尼日利亚', enName: 'Nigeria' },
  { value: 'NIC', text: '尼加拉瓜', enName: 'Nicaragua' },
  { value: 'NIU', text: '纽埃', enName: 'Niue' },
  { value: 'NLD', text: '荷兰', enName: 'Netherlands' },
  { value: 'NOR', text: '挪威', enName: 'Norway' },
  { value: 'NPL', text: '尼泊尔', enName: 'Nepal' },
  { value: 'NRU', text: '瑙鲁', enName: 'Nauru' },
  { value: 'NZL', text: '新西兰', enName: 'New Zealand' },
  { value: 'OMN', text: '阿曼', enName: 'Oman' },
  { value: 'PAK', text: '巴基斯坦', enName: 'Pakistan' },
  { value: 'PAN', text: '巴拿马', enName: 'Panama' },
  { value: 'PCN', text: '皮特凯恩群岛', enName: 'Pitcairn Islands' },
  { value: 'PER', text: '秘鲁', enName: 'Peru' },
  { value: 'PHL', text: '菲律宾', enName: 'The Philippines' },
  { value: 'PLW', text: '帕劳', enName: 'Palau' },
  { value: 'PNG', text: '巴布亚新几内亚', enName: 'Papua New Guinea' },
  { value: 'POL', text: '波兰', enName: 'Poland' },
  { value: 'PRI', text: '波多黎各', enName: 'Puerto Rico' },
  { value: 'PRK', text: '朝鲜', enName: 'North Korea' },
  { value: 'PRT', text: '葡萄牙', enName: 'Portugal' },
  { value: 'PRY', text: '巴拉圭', enName: 'Paraguay' },
  { value: 'PST', text: '巴勒斯坦', enName: 'Palestinian territories' },
  { value: 'PYF', text: '法属波利尼西亚', enName: 'French polynesia' },
  { value: 'QAT', text: '卡塔尔', enName: 'Paraguay' },
  { value: 'REU', text: '留尼汪', enName: 'Réunion' },
  { value: 'ROM', text: '罗马尼亚', enName: 'Romania' },
  { value: 'RUS', text: '俄罗斯', enName: 'Russian Federation' },
  { value: 'RWA', text: '卢旺达', enName: 'Rwanda' },
  { value: 'SAU', text: '沙特阿拉伯', enName: 'Saudi Arabia' },
  { value: 'SDN', text: '苏丹', enName: 'Sudan' },
  { value: 'SEN', text: '塞内加尔', enName: 'Senegal' },
  { value: 'SGP', text: '新加坡', enName: 'Singapore' },
  {
    value: 'SGS',
    text: '南乔治亚岛和南桑德韦奇岛',
    enName: 'South Georgia and the South Sandwich Islands'
  },
  { value: 'SHN', text: '圣赫勒拿', enName: 'St. Helena & Dependencies' },
  {
    value: 'SJM',
    text: '斯瓦尔巴群岛',
    enName: 'Template:Country data SJM Svalbard	'
  },
  { value: 'SLB', text: '所罗门群岛', enName: 'Solomon Islands' },
  { value: 'SLE', text: '塞拉利昂', enName: 'Sierra Leone' },
  { value: 'SLV', text: '萨尔瓦多', enName: 'El Salvador' },
  { value: 'SMR', text: '圣马力诺', enName: 'San Marino' },
  { value: 'SOM', text: '索马里', enName: 'Somalia' },
  { value: 'SRB', text: '塞尔维亚', enName: 'Serbia' },
  {
    value: 'SPM',
    text: '圣皮埃尔和密克隆',
    enName: 'Saint-Pierre and Miquelon'
  },
  { value: 'STP', text: '圣多美和普林西比', enName: 'Sao Tome & Principe' },
  { value: 'SUR', text: '苏里南', enName: 'Suriname' },
  { value: 'SVK', text: '斯洛伐克', enName: 'Slovakia' },
  { value: 'SVN', text: '斯洛文尼亚', enName: 'Slovenia' },
  { value: 'SWE', text: '瑞典', enName: 'Sweden' },
  { value: 'SWZ', text: '斯威士兰', enName: 'Swaziland' },
  { value: 'SYC', text: '塞舌尔', enName: 'Seychelles' },
  { value: 'SYR', text: '叙利亚', enName: 'Syria' },
  {
    value: 'TCA',
    text: '特克斯和凯科斯群岛',
    enName: 'Turks & Caicos Islands	'
  },
  { value: 'TCD', text: '乍得', enName: 'Chad' },
  { value: 'TGO', text: '多哥', enName: 'Togo' },
  { value: 'THA', text: '泰国', enName: 'Thailand' },
  { value: 'TJK', text: '塔吉克斯坦', enName: 'Tajikistan' },
  { value: 'TKL', text: '托克劳', enName: 'Tokelau' },
  { value: 'TKM', text: '土库曼斯坦', enName: 'Turkmenistan' },
  { value: 'TMP', text: '东帝汶', enName: 'Timor-Leste (East Timor)' },
  { value: 'TON', text: '汤加', enName: 'Tonga' },
  { value: 'TTO', text: '特立尼达和多巴哥', enName: 'Trinidad & Tobago' },
  { value: 'TUN', text: '突尼斯', enName: 'Tunisia' },
  { value: 'TUR', text: '土耳其', enName: 'Turkey' },
  { value: 'TUV', text: '图瓦卢', enName: 'Tuvalu' },
  { value: 'TZA', text: '坦桑尼亚', enName: 'Tanzania' },
  { value: 'UGA', text: '乌干达', enName: 'Uganda' },
  { value: 'UKR', text: '乌克兰', enName: 'Ukraine' },
  { value: 'URY', text: '乌拉圭', enName: 'Uruguay' },
  { value: 'USA', text: '美国', enName: 'United States of America (USA)' },
  { value: 'UZB', text: '乌兹别克斯坦', enName: 'Uzbekistan' },
  { value: 'VAT', text: '梵蒂冈', enName: 'Vatican City (The Holy See)' },
  {
    value: 'VCT',
    text: '圣文森特和格林纳丁斯',
    enName: 'St. Vincent & the Grenadines'
  },
  { value: 'VEN', text: '委内瑞拉', enName: 'Venezuela' },
  { value: 'VGB', text: '英属维尔京群岛', enName: 'British Virgin Islands' },
  {
    value: 'VIR',
    text: '美属维尔京群岛',
    enName: 'United States Virgin Islands'
  },
  { value: 'VNM', text: '越南', enName: 'Vietnam' },
  { value: 'VUT', text: '瓦努阿图', enName: 'Vanuatu' },
  { value: 'WLF', text: '瓦利斯和富图纳群岛', enName: 'Wallis and Futuna' },
  { value: 'WSM', text: '西萨摩亚', enName: 'Samoa' },
  { value: 'YEM', text: '也门', enName: 'Yemen' },
  { value: 'YUG', text: '南斯拉夫', enName: 'Yugoslavia' },
  { value: 'ZAF', text: '南非', enName: 'South Africa' },
  { value: 'ZAR', text: '扎伊尔', enName: 'Zaire' },
  { value: 'ZMB', text: '赞比亚', enName: 'Zambia' },
  { value: 'ZWE', text: '津巴布韦', enName: 'Zimbabwe' }
]
